const DB_NAME = 'tesla-videoplayer-folders';
const STORE = 'folders';
const LAST = 'last';

function openDatabase(): Promise<IDBDatabase | undefined> {
  return new Promise((resolve) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(undefined);
  });
}

function settle<T>(request: IDBRequest<T>): Promise<T | undefined> {
  return new Promise((resolve) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(undefined);
  });
}

export async function rememberFolder(handle: FileSystemDirectoryHandle): Promise<void> {
  const db = await openDatabase();
  if (db) await settle(db.transaction(STORE, 'readwrite').objectStore(STORE).put(handle, LAST));
}

export async function rememberedFolder(): Promise<FileSystemDirectoryHandle | undefined> {
  const db = await openDatabase();
  if (!db) return undefined;
  const handle = await settle<unknown>(db.transaction(STORE).objectStore(STORE).get(LAST));
  return handle instanceof FileSystemDirectoryHandle ? handle : undefined;
}

export async function ensureReadable(handle: FileSystemDirectoryHandle): Promise<boolean> {
  if ((await handle.queryPermission?.({ mode: 'read' })) === 'granted') return true;
  return (await handle.requestPermission?.({ mode: 'read' })) === 'granted';
}
